import { Injectable } from '@angular/core';
import { ILanguage } from '../language/language.model';
import { IdName } from '../../common-interfaces';

@Injectable({
  providedIn: 'root',
})
export class MultiLangService {

  getValue(obj: any, basePropName: string, language: ILanguage): string {
    const propKey = this.multiLangPropKey(basePropName, language);
    return  obj[propKey];
  }

  hasValue(obj: any, basePropName: string, language: ILanguage): boolean {
    const value = this.getValue(obj, basePropName, language);
    return value !== null && value !== '';
  }

  setValue(obj: any, basePropName: string, propValue: string, language: ILanguage) {
    const propKey = this.multiLangPropKey(basePropName, language);
    obj[propKey] = propValue;
  }

  getNameInFirstLanguage(obj: any, languages: ILanguage[]): string {
    return this.getValueInFirstLanguage(obj, 'name', languages);
  }

  toIdNameInFirstLanguage(items: any[], languages: ILanguage[]): IdName[] {
    return items.map(item => {
      return {
        id: item.id,
        name: this.getNameInFirstLanguage(item, languages),
      };
    });
  }

  getValueInFirstLanguage(obj: any, basePropName: string, languages: ILanguage[]): string {
    const firstDefined = languages.find(language => this.hasValue(obj, basePropName, language));
    if(firstDefined != null) {
      return this.getValue(obj, basePropName, firstDefined);
    }
    return null;
  }

  getNameDefinedLanguages(obj: any, languages: ILanguage[]): string {
    return this.getDefinedLanguages(obj, 'name', languages);
  }

  getDefinedLanguages(obj: any, basePropName: string, languages: ILanguage[]): string {
    return languages
      .filter(language => this.hasValue(obj, basePropName, language))
      .map(language => language.name)
      .join(', ');
  }

  hasValueMatching(obj: any, basePropName: string, languages: ILanguage[], matchedString): boolean {
    let isMatched: boolean = false;

    for(let index = 0; index < languages.length; index++) {
      const value = this.getValue(obj, basePropName, languages[index]);

      if (value !== null && value !== '' && value.toLowerCase().includes(matchedString.toLowerCase())) {
        isMatched = true;
        break;
      }
    }
    return isMatched;
  }


  private multiLangPropKey(basePropName: string, language: ILanguage): string {
    return language.id === 1 ? basePropName : `${basePropName}${language.id}`;
  }

}
